<template>
    <v-layout style='flex: 0 0 auto !important;' column>
        <v-progress-linear :color = '$store.getters.uiAccent' class='mb-0 py-0 mt-0' height='1' :active='indicator' :indeterminate='true'></v-progress-linear>
        <v-card tile flat>
            <v-card-text class = 'pa-0'>
                <v-list subheader>
                    <v-list-item link v-if = '!reports.length && !indicator' class = 'px-0'>
                        <v-list-item-content>
                            <v-list-item-title>Отчеты не подключены</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if = '!reports.length && !indicator'></v-divider>
                    <v-list-group
                      no-action 
                      v-for='s in reports' 
                      :key='`report_${s.report_id}`'
                      style='border-bottom: 1px solid;border-color:#EEEEEE;'
                    >
                        <template v-slot:activator>
                            <v-list-item class = 'px-0'>
                                <v-list-item-content>
                                    <v-list-item-title>{{s.name}}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action class='mx-0' v-if = 'currentUserReportIds.includes(s.report_id)'>
                                    <v-btn small icon link :to="{ name: 'report', params: {'report_id': s.report_id} }">
                                        <v-icon small color='green darken-2'>insert_chart_outlined</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                        <template v-if = 's && s.users && s.users.length > 0' >
                            <v-list-item 
                                three-line
                                link
                                v-for = 'u in s.users' 
                                :key = 'u.uid+"_"+s.report_id'
                            >
                                <v-list-item-content>
                                    <v-list-item-title>{{u.name}} {{u.lastname}}</v-list-item-title>
                                    <v-list-item-subtitle>{{u.mode_name}}</v-list-item-subtitle>
                                    <v-list-item-subtitle>Доступы действуют <b v-if = '!u.expire_on'>бессрочно</b><b v-else> до {{formatTime(u.expire_on)}}</b></v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action v-if = 'reportUserUpdateAllowed' style='min-width: auto !important;' class = 'my-auto'>
                                    <user-report-update :data='u' :postAction='getProjectReports' :report='s'></user-report-update>
                                </v-list-item-action>
                                <v-list-item-action v-if = 'reportUserUpdateAllowed' style='min-width: auto !important;' class = 'mx-0 my-auto'>
                                    <user-report-delete :data='u' :postAction='getProjectReports' :report='s'></user-report-delete>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item link v-if = '!s.users || s.users.length == 0'>
                                <v-list-item-content>
                                    <v-list-item-title>Пользователей не назначено</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <user-report-create v-if='reportUserCreateAllowed' :postAction='getProjectReports' :report='s'></user-report-create>
                        </template>
                    </v-list-group>
                </v-list>
            </v-card-text>
        </v-card>
    </v-layout>
</template>

<script>

import UserReportCreate from '@/components/entities/users/reports/CreateDialog.vue'
import UserReportDelete from '@/components/entities/users/reports/DeleteMenu.vue'
import UserReportUpdate from '@/components/entities/users/reports/UpdateMenu.vue'

import projectHandlers from '@/mixins/project'
import { orderBy } from 'lodash-es'
import dayjs from 'dayjs'

export default {
    name: 'ProjectReportsGrants',
    props: ['data'],
    mixins: [projectHandlers],
    components: {
        'user-report-create': UserReportCreate,
        'user-report-delete': UserReportDelete,
        'user-report-update': UserReportUpdate
    },
    data() {
        return {
            project: this.data,
            reports: [],
            cursorReport: {},
            indicator: false,
            valid: false,
            rules: {
                required: value => !!value || 'Обязательное поле.'
            }
        }
    },
    computed: {
        reportUserCreateAllowed() {
            return this.project.mode_persons != 'R'
        },
        reportUserUpdateAllowed() {
            return ['X', 'U'].includes(this.project.mode_persons)
        },
        currentUserReportIds() {
            return this.$store.state.userData.reports.map(r => r.report_id)
        }
    },
    watch: {
        data(value) {
            this.project = value
            this.reports = []
            this.getProjectReports()
        },
        reports(value) {
            if (Array(value).length != 0) {
                this.getReportsPersons()
            }
        }
    },
    methods: {
        formatTime(time) {
           return dayjs(time).format('D MMM YYYY')
        },
        getProjectReports() {
            this.indicator = true;
            this.getProjectPropertyPromise('reports').then((r) => {
                let response = r.body
                this.indicator = false
                if (response.result) {
                    this.reports = orderBy(response.data || [], 'report_name');
                } else {
                    console.log('error fetch project reports', response.data)
                }
            });
        },
        getReportsPersons() {
            this.$http.get(this.$store.getters.endpoint + '/db/reports/persons', {
                emulateJSON: true,
                params: { 'login': this.$store.getters.userLogin, 'report_id': this.reports.map((r) => r.report_id) },
                headers: { ...this.$store.state.restrictedHeaders, ...{ 'Authorization': 'Bearer ' + this.$store.getters.userToken } }
            }).then( (r) => {
                let response = r.body
                if (response.result) {
                    for (let i = 0; i < this.reports.length; i++) {
                        this.reports[i]['users'] = response.data.filter((ur) => ur.report_id == this.reports[i].report_id) || []
                    };
                    this.$set(this.reports, this.reports);
                } else {
                    console.log('error fetch reports persons', response.data)
                }
            });
        }
    },
    mounted() {
        this.getProjectReports();
    }
}
</script>